export default __webpack_public_path__ + "static/media/Apple-gray.80530772.svg";